import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Mail, MapPin } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-900 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center mb-6">
              <img 
                src="/logo.png" 
                alt="AUDC Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-green-500 to-emerald-400 tracking-tighter -ml-1">
                .devs
              </span>
            </Link>
            <p className="text-slate-500 leading-relaxed tracking-tight">
              The official software developers club of Ambo University - Hachalu Campus.
              Dedicated to fostering a culture of innovation and excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-xs tracking-widest">Quick Links</h4>
            <ul className="space-y-4">
              {['Home', 'Events', 'News', 'Members', 'Subgroups'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase()}`}
                    className="text-slate-500 hover:text-green-500 transition-colors tracking-tight"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-xs tracking-widest">Connect</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-500 tracking-tight">
                <Mail size={18} className="text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm break-all">ambouniversitydevelopersclub@gmail.com</span>
              </li>
              <li className="flex items-center gap-3 text-slate-500 tracking-tight">
                <MapPin size={18} className="text-green-500" />
                <span>Ambo University, Hachalu Campus</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase text-xs tracking-widest">Social Media</h4>
            <div className="flex gap-4">
              {[
                { icon: Github, href: '#' },
                { icon: Linkedin, href: '#' },
                { icon: Mail, href: 'mailto:ambouniversitydevelopersclub@gmail.com' },
              ].map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="w-10 h-10 rounded-lg border border-slate-800 flex items-center justify-center text-slate-500 hover:bg-slate-900 hover:text-green-500 hover:border-green-900/50 transition-all"
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-600">
          <p className="tracking-tight">
            © {new Date().getFullYear()} Ambo University Developers Club. All rights reserved.
          </p>
          <div className="flex gap-8 tracking-tight">
            <Link to="/privacy" className="hover:text-green-500 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/code-of-conduct" className="hover:text-green-500 transition-colors">
              Code of Conduct
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

